function padStr(i) {
    return (i < 10) ? "0" + i : "" + i;
}

const utils = {};

utils.dateFormat = function (date) {
    if (date instanceof Date) {
        var dd = padStr(date.getDate());
        var mm = padStr(date.getMonth() + 1); //January is 0!
        var yyyy = date.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
    }
};

utils.timeFormat = function (date) {
    if (date instanceof Date) {
        var hh = padStr(date.getHours());
        var mm = padStr(date.getMinutes());
        return `${hh}:${mm}:00`;
    }
}

utils.addMonthsUTC = function (date, count) {
    if (date && count) {
        date = new Date(+date);
        var m, d = date.getUTCDate()
        date.setUTCMonth(date.getUTCMonth() + count, 1)
        m = date.getUTCMonth()
        date.setUTCDate(d)
        if (date.getUTCMonth() !== m) date.setUTCDate(0)
    }
    return date
}

utils.strToDate = function (str) {
    let dateArr = str.split('-');
    return new Date(`${dateArr[1]}-${dateArr[2]}-${dateArr[0]}`);
}

utils.calculateAge = function (year) {
    const today = new Date();
    const thisYear = today.getFullYear();
    let age = thisYear - parseInt(year);
    if (age < 1) {
        age = 'Less than 1 year';
    } else if (age === 1) {
        age = '1 year';
    } else {
        age += ' years'
    }
    return age;
}

utils.monthDiff = function (d1, d2) {
    if (d1 && d2) {
        const date1 = new Date(d1);
        const date2 = new Date(d2);
        let months;
        months = (date2.getFullYear() - date1.getFullYear()) * 12;
        months -= date1.getMonth();
        months += date2.getMonth();
        return months
    }
    return 0;
}

export default utils;


// WEBPACK FOOTER //
// ./src/utils/date.js